<template>
  <div class="flex flex-col items-center text-center">
    <div
      class="h-4 w-4 rounded-full"
      :class="{
        'border bg-green-300': isComplete,
        'border border-green-300': isCurrent,
        'border border-white': isIncomplete,
      }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    stepNumber: {
      type: Number,
      required: true,
    },
    currentStepNumber: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isCurrent() {
      return this.stepNumber === this.currentStepNumber;
    },
    isComplete() {
      return this.stepNumber < this.currentStepNumber;
    },
    isIncomplete() {
      return this.stepNumber > this.currentStepNumber;
    },
  },
};
</script>
